import React, { useRef } from 'react'
import { PhyronSettings } from '../../../helpers/PhyronHelper'

const Phyron = ({regnr}) => {

    const player = useRef()

    return (
        <>
                <video
                    ref={player}
                    className="phyron-video slide-image"
                    data-campaign="bilbolaget-nu"
                    data-product-key={regnr}
                    data-file={PhyronSettings.dimesions}
                    data-tracking-source="phyron"
                    data-callback=""
                    controls={false}
                    muted={true}
                    autoPlay={true}
                    playsInline={true}
                    onClick={(e) => { 
                        if( player.current.currentTime > 0 && !player.current.paused && !player.current.ended && player.current.readyState > 2 ) {
                            player.current.pause() 
                        } else {
                            player.current.play() 
                        }
                    }}
                    src={`https://bilbolaget-nu.cust.se.phyron.com/repo/${regnr}/${PhyronSettings.dimesions}.mp4`}
                    poster={`https://bilbolaget-nu.cust.se.phyron.com/repo/${regnr}/${PhyronSettings.dimesions}.jpg`}
                    preload="none">
                </video>
        </>
    )
}


export default Phyron